export default __webpack_public_path__ + "media/images/images/gallery/3-8f9da3c072bced517d010a196bfbc25c.jpg";